import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { AuthService } from '../shared/services/auth.service';
import { SidenavService } from './sidenav.service';
import { Subscription } from 'rxjs';

export type SidenavPages =
  | 'login'
  | 'register'
  | 'contact'
  | 'weather'
  | 'settings'
  | 'mfa'
  | 'download-handbooks';

interface SidenavEvent {
  page: SidenavPages;
  data?: any;
}

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent implements AfterViewInit {
  sidenavPage?: SidenavPages;
  changeStatus: boolean = false;

  private subscription!: Subscription;
  downloadHandbookData: any;

  @ViewChild('sidenav') controller?: MatSidenav;

  constructor(private auth: AuthService, private service: SidenavService) {
    this.service.pageChanges.subscribe((page) => this.openSidenav(page));
  }

  ngAfterViewInit(): void {
    if (this.auth.needChangePassword()) {
      setTimeout(() => this.forcePasswordChange(), 1000);
    }
  }

  openSidenav(page: any) {
    this.changeStatus = !this.changeStatus;
    if (page.data) {
      this.sidenavPage = page.page;
      this.downloadHandbookData = page.data;
    } else {
      this.sidenavPage = page;
    }
    this.controller?.open();
  }

  forcePasswordChange() {
    this.openSidenav('settings');
    this.controller!.disableClose = true;
  }

  public closeNotification(): void {
    // this.service.notifyClosed();
  }
}
